import { ITemplateCategoryView } from 'apis/models';
import React, { FC, useEffect, useState } from 'react';
import CategoryLine from '../CatagaryLine';
import './index.less';

interface ICategoryProps {
  value?: number[];
  list: ITemplateCategoryView[];
  onChange?: (selectedList: number[]) => void;
}
const Category: FC<ICategoryProps> = (props) => {
  const { list, onChange, value } = props;
  const [selectedList, setSelectedList] = useState<number[]>(value ?? []);
  useEffect(() => {
    setSelectedList(value ?? []);
  }, [value]);
  return (
    <div>
      {list.map((cat, index) => (
        <CategoryLine
          value={selectedList[index]}
          key={cat.id}
          title={cat.title}
          list={cat.subCategory.map((item: any) => ({
            id: item.id,
            value: item.name,
          }))}
          onChange={(key) => {
            const changeList = [...selectedList];
            changeList[index] = key;
            setSelectedList(changeList);
            onChange?.(changeList);
          }}
        />
      ))}
    </div>
  );
};

export default Category;
